import { MapPin, Phone } from 'lucide-react';
import { COMPANY, SERVICE_AREAS } from '../mock/data';

export default function ServiceArea() {
  return (
    <section className="py-24 lg:py-32 bg-ink-soft border-y border-white/5">
      <div className="max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-2 gap-14 items-center">
        <div>
          <div className="eyebrow">Where We Work</div>
          <h2 className="section-title">Proudly serving Shreveport &amp; the ArkLaTex.</h2>
          <p className="section-lede">
            Based in Shreveport, Louisiana, we install fences and decks for homeowners and businesses across the region. If you&rsquo;re nearby, we come to you — free estimate, no obligation.
          </p>

          <div className="mt-8 grid grid-cols-2 sm:grid-cols-3 gap-x-6 gap-y-3">
            {SERVICE_AREAS.map(a => (
              <div key={a} className="flex items-center gap-2 text-cream">
                <MapPin className="w-4 h-4 text-gold shrink-0" />
                <span className="text-sm font-medium">{a}</span>
              </div>
            ))}
          </div>

          <div className="mt-10 flex flex-wrap gap-3">
            <a href={`tel:${COMPANY.phoneRaw}`} className="btn-primary">
              <Phone className="w-4 h-4" /> {COMPANY.phone}
            </a>
            <a href="#quote" className="btn-outline">Fill Out Form</a>
          </div>
        </div>

        <div className="relative rounded-md overflow-hidden shadow-2xl aspect-[4/3] lg:aspect-square border border-white/10">
          <img
            src="/gallery/06-cedar-with-trailer.jpg"
            alt="Better Fence &amp; Deck crew work"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/40 to-transparent" />
          <div className="absolute bottom-0 left-0 right-0 p-8 text-cream">
            <div className="font-display uppercase text-3xl tracking-tight">Ready for your free estimate?</div>
            <p className="mt-2 text-cream/80">Call now or fill out the form — we respond fast.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
